module.exports = "/img/mail.png?faa9bdb3a47cc1f2a98bfe7052dbc655";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/mail.png
// module id = kK13
// module chunks = 75